import util from '@/libs/util'

const post = util.ajax.post
const get = util.ajax.get

export const homeDetailUrls = [
  // 查询设备信息
  '/tailgasdevice/detailbycode',
  // 查询设备列表信息
  '/tailgasdevice/detectionlist'
]

export const homeDetail = {}

homeDetail.deviceDetail = function (params) {
  return get('/tailgasdevice/detailbycode?deviceCode=' + params)
}
homeDetail.listDeviceDetail = function (params) {
  return post('/tailgasdevice/detectionlist', params)
}
homeDetail.listDPFDetail = function (params) {
  return post('/washdevice/list', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/home/homedetail.js